import { render, staticRenderFns } from "./NewMember.vue?vue&type=template&id=24c15bdb"
import script from "./NewMember.vue?vue&type=script&lang=js"
export * from "./NewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports